<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
  },
  data() {
    return {
      errorMessage: "",
      title: "E Ticket Update",
      items: [
        {
          text: "E Ticket",
          href: "/",
        },
        {
          text: "Update",
          active: true,
        },
      ],

      errors: null,
        passengers:[],
        tickets:[],
      searchreferencekey: "",
        fromBookingList:false,
        ticketno:[],
        passengerid:[],
      submitform: false,
      submitted: false,
        visible:false,
        message:"",
        lineError:true,
    };
  },
  created() {
    this.searchreferencekey = this.$route.params.searchReferenceKey;
    this.fromBookingList=this.$route.params.isFromBookingList;
  },
  mounted() {
    this.getTicketDetail();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    async getTicketDetail() {
      try {
        axios
          .post("/api/ticket/edit/" + this.searchreferencekey, {
            accessToken: localStorage.getItem("access_tocken"),
          })
          .then((response) => {
            if (response.data.status) {
                const ticketInfo=response.data.data.flight_passengers;
                let tick=response.data.data.flight_tickets;
                var i;
                let ass=new Array();
                if(tick.length==0){
                    for(i=0;i<ticketInfo.length;i++){
                        ass[i]={ticket_no:''};
                    }
                    this.tickets=ass;
                }else{
                    this.tickets=tick;
                }
              this.passengers= ticketInfo;

            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    formSubmit(event) {
      this.submitted = true;
      axios
        .post("/api/ticket/update", {
          passengers: this.passengers,
            tickets:this.tickets,
          search_ref_key: this.searchreferencekey,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$swal("Data Updated", "success");
            if(this.fromBookingList!=true){
                this.$router.push({ name: "flight_ticket_list" });
            }else{
                this.$router.push({name: "flight_booking_list"});
            }
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.lineError=false;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors && lineError" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="roleUpdateForm" @submit.prevent="formSubmit">
                <div class="row">
                    <div class="col-md-3" v-for="(passenger,index) in passengers" v-bind:key="index">
                        <h4>Passenger {{index+1}}</h4>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Prefix</label>
                                <input
                                    id="prefix+'index'"
                                    v-model="passenger.prefix"
                                    name="prefix+'index'"
                                    type="text"
                                    disabled
                                    class="form-control"
                                    placeholder="passenger prefix"
                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].prefix.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].prefix.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>First Name</label>
                                <input
                                    id="passenger_info+'index'"
                                    v-model="passenger.first_name"
                                    name="passenger_info+'index'"
                                    type="text"
                                    disabled
                                    class="form-control"
                                    placeholder="passenger first name"
                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].first_name.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].first_name.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Last Name</label>
                                <input
                                    id="last_name+'index'"
                                    v-model="passenger.last_name"
                                    name="last_name+'index'"
                                    type="text"
                                    disabled
                                    class="form-control"
                                    placeholder="passenger last name"
                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].last_name.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].last_name.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <b-form-group
                                id="last_name+'index'"
                                label-cols-sm="12"
                                label-cols-lg="12"
                                label="Birth Date"
                                label-for="end_dateTime"
                            >
                                <b-form-datepicker id="birth_date+'index'" v-model="passenger.date_of_birth" value="passenger.date_of_birth"  class="mb-2"></b-form-datepicker>
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.passenger_info[index].date_of_birth.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.passenger_info[index].date_of_birth.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </b-form-group>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Passenger Type</label>
                                <input
                                    id="passenger_type"
                                    v-model="passenger.passenger_type"
                                    name="passenger_type"
                                    type="text"
                                    class="form-control"
                                    placeholder="passenger type"

                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].passenger_type.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].passenger_type.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Is Lead Passenger</label>
                                <select
                                    id="is_lead_pax+'index'"
                                    v-model="passenger.is_lead_pax"
                                    name="trip_type"
                                    type="text"
                                    class="form-control"
                                    placeholder="is lead passenger"
                                >
                                    <option value="" disabled style="display:none" selected>Is lead pax</option>
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                </select>
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.passenger_info[index].is_lead_pax.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.passenger_info[index].is_lead_pax.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Gender</label>
                                <select
                                    id="gender+'index'"
                                    v-model="passenger.gender"
                                    name="gender+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type gender"
                                    value
                                >
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.passenger_info[index].gender.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.passenger_info[index].gender.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Nationality</label>
                                <input
                                    id="nationality+'index'"
                                    v-model="passenger.nationality"
                                    name="nationality+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="passenger type"

                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].nationality.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].nationality.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Base Fare</label>
                                <input
                                    id="base_fare+'index'"
                                    v-model="passenger.base_fare"
                                    name="base_fare+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="base fare"
                                />

                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Gross Fare</label>
                                <input
                                    id="gross_fare+'index'"
                                    v-model="passenger.gross_fare"
                                    name="gross_fare+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="gross fare"
                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].gross_fare.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].gross_fare.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Total Tax</label>
                                <input
                                    id="total_tax+'index'"
                                    v-model="passenger.total_tax"
                                    name="total_tax+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="total tax"

                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].total_tax.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].total_tax.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Invoice Fare</label>
                                <input
                                    id="invoice_fare+'index'"
                                    v-model="passenger.invoice_fare"
                                    name="invoice_fare+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="invoice fare"
                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].invoice_fare.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].invoice_fare.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Passport No.</label>
                                <input
                                    id="passport_no+'index'"
                                    v-model="passenger.passport_no"
                                    name="passport_no+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="passport number"
                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].passport_no.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].passport_no.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Ticket No.</label>
                                <input
                                    id="ticket_no'index'"
                                    v-model="tickets[index].ticket_no"
                                    name="ticket_no+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter Ticket Number"
                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].passport_no.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].passport_no.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
              <button class="btn btn-primary" type="submit">Issue Ticket</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
